<template>
  <el-dialog
    title="关联付款单"
    :visible.sync="dialogVisible"
    width="80%"
    class="paymentDialog"
    id="paymentDialog"
    @close="closeDialog"
  >
    <!-- 表格 -->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          @click="insertRow()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          @click="deleteRow()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
        <vxe-button @click="save()" type="primary" icon="el-icon-files" class="vxe-btn-primary">{{
          $t('xTable.save')
        }}</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      column-min-width="120"
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      :custom-config="{ storage: true }"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
  </el-dialog>
</template>
<script>
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import SearchTable from '@/components/form-item/search-table';
  import API from '@/api/capitalCenter/receivablesManage';
  export default {
    data() {
      return {
        tableHeight: document.body.clientHeight - 400 + 'px' || 0,
        dialogVisible: false,
        load: false,
        tableData: [],
        addRowObj: {
          paymentNum: null,
          lineNumber: null,
          paymentAmount: null,
          refundAmount: null,
        },
        registerNo: null,
        registerClaimId: null,
        claimDepartmentNo: null,
        claimAmount: null,
        rules: {
          paymentNum: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.paymentNumPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          lineNumber: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.lineNumberPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          refundAmount: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.refundAmountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    components: {
      // inputNumberAd,
      // SearchTable,
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50, fixed: 'left' },
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManage.paymentInfo.seq'),
            fixed: 'left',
          },
          {
            // 付款单
            field: 'paymentNum',
            title: this.$t('receivablesManage.paymentInfo.paymentNum'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.paymentNum}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="payment"
                    isMultiple={true}
                    currentValue={row.paymentNum}
                    checkRowKeys={[row.paymentNum]}
                    onInput={(val) => this.chooseTable(val, row, 'paymentNum')}
                    extraData={{
                      paymentApplyDepartmentNo: this.claimDepartmentNo,
                    }}
                  ></search-table>,
                ];
              },
            },
          },
          {
            // 行号
            field: 'lineNumber',
            title: this.$t('receivablesManage.paymentInfo.lineNumber'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.lineNumber}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="payment"
                    isMultiple={true}
                    currentValue={row.lineNumber}
                    checkRowKeys={[row.lineNumber]}
                    onInput={(val) => this.chooseTable(val, row, 'lineNumber')}
                    extraData={{
                      paymentApplyDepartmentNo: this.claimDepartmentNo,
                    }}
                  ></search-table>,
                ];
              },
            },
          },
          {
            // 付款单金额
            field: 'paymentAmount',
            title: this.$t('receivablesManage.paymentInfo.paymentAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.paymentAmount)}</span>];
              },
            },
          },
          {
            // 退款金额
            field: 'refundAmount',
            title: this.$t('receivablesManage.paymentInfo.refundAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.refundAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.refundAmount}
                    max={999999999.99}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'refundAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
        ];
      },
    },
    mounted() {},
    methods: {
      openDialog(item) {
        // 打开
        this.dialogVisible = true;
        this.registerNo = item.registerNo;
        this.registerClaimId = item.id;
        this.claimDepartmentNo = item.claimDepartmentNo;
        this.claimAmount = item.originReceiveMoneyAmount
          ? item.originReceiveMoneyAmount
          : item.originProformaInvoiceAmount;
        this.getData();
      },
      closeDialog() {
        // 关闭
        this.dialogVisible = false;
        this.tableData = [];
        ['registerNo', 'registerClaimId', 'claimDepartmentNo', 'claimAmount'].map((item) => {
          this[item] = null;
        });
      },
      async getData() {
        // 获取关联付款单信息
        this.load = true;
        let res = await this.$axios.post(API.QUERY_COLLECTIONPAY_LIST, {
          registerClaimId: this.registerClaimId,
          registerNo: this.registerNo,
        });
        if (res) {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        // 保存
        let params = await this.exportChildData();
        let refundAmountSum = 0;
        params.map((item) => {
          refundAmountSum = this.$cal.calCommon(item.refundAmount, refundAmountSum, '+');
        });
        if (this.$cal.calCommon(refundAmountSum, this.claimAmount, '-') > 0) {
          return this.$message({
            showClose: true,
            message: '总的关联的退款金额不能大于该行项目认领金额！',
            type: 'error',
          });
        }
        if (params) {
          params = params.map((item) => {
            return this.$baseRequest.assignObj({
              ...item,
              registerClaimId: this.registerClaimId,
              registerNo: this.registerNo,
            });
          });
          this.loading.startLoading();
          let res = await this.$axios.post(API.SAVE_COLLECTIONPAY, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.closeDialog();
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          }
        }
      },
      insertRow(row) {
        let record = { ...this.addRowObj };
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      deleteRow() {
        const selectedList = this.$refs.table.getSelectRecords();
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
        }
        let params = [];
        selectedList.map((item) => {
          if (item.id) {
            params.push(item.id);
          }
        });
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.loading.startLoading();
            this.$axios.post(API.DEL_COLLECTIONPAY, params).then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({ showClose: true, type: 'success', message: res.data.msg });
                this.$refs.table.removeSelecteds();
              } else {
                this.$message({ showClose: true, type: 'error', message: res.data.msg });
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      chooseTable(val, row, prop) {
        if (['paymentNum', 'lineNumber'].indexOf(prop) != -1) {
          ['paymentNum', 'lineNumber', 'paymentAmount'].map((item) => {
            row[item] = val[0][item];
          });
        } else {
          row[prop] = val;
        }
        this.updateData();
      },
      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate().then(() => {
            resolve(tableData);
          });
        });
      },
      updateData() {
        // 在值发生改变时更新数据
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      footerMethod({ columns, data }) {
        // 一次认领表尾合计
        let returnAmountProps = ['refundAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return '合计';
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
